import { jsx as _jsx } from "react/jsx-runtime";
export const LineTurn = () => {
    return (_jsx("svg", Object.assign({ style: { marginTop: '-0.4rem', opacity: 1 }, width: '16', viewBox: '0 0 16 25', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M16 16C11.5817 16 8 12.4183 8 8L8 0L8 32', stroke: '#e8e8e8' }) })));
};
